module.exports = "/assets/063f9b89e01208e0d6d31d9a1da129eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/AX.png
// module id = 1211
// module chunks = 0